import './MainLayout.css';
import { Outlet, useLocation, useOutletContext, NavLink } from 'react-router-dom';
import Navbar from '../components/Navbar/Navbar.js';
import Sidebar from '../components/Sidebar/Sidebar.js';
import { CategoryProvider } from '../CategoryContext.js';
import Footnote from '../components/Sidebar/Footnote/Footnote.js';
import { Button } from '@mui/material';
import GlobalBanner from '../components/GlobalBanner/GlobalBanner.js';
import ScrollToTop from '../components/ScrollToTop';

const MainLayout = () => {
  const location = useLocation();
  const parentOutletContext = useOutletContext();

  // The Video Guides page gets its own full-height, non-scrolling layout with
  // no footer/Support button.
  const isVideoGuides = location.pathname.includes('video-guides');

  let displaySidebar;
  if (
    location.pathname.includes('/edit') ||
    location.pathname.includes('/add') ||
    location.pathname.includes('tryrnai') ||
    isVideoGuides
  ) {
    displaySidebar = false;
  } else {
    displaySidebar = true;
  }

  if (isVideoGuides) {
    return (
      <CategoryProvider>
        <ScrollToTop />
        <Navbar />
        <div className="video-guides-layout">
          <Outlet context={parentOutletContext} />
        </div>
      </CategoryProvider>
    );
  }

  return (
    <CategoryProvider>
      <ScrollToTop />
      <Navbar />

      {displaySidebar ? (
        <>
          <Sidebar />
          <div className="showSidebar">
            <GlobalBanner />
            <Outlet context={parentOutletContext} />
          </div>
        </>
      ) : (
        <div className="page-wrapper">
          <div className="content-wrapper">
            <div className="centered-banner">
              <GlobalBanner />
            </div>
            <Outlet context={parentOutletContext} />
          </div>
          <footer className="footer-container">
            <Button
              variant="contained"
              component={NavLink}
              to="/video-guides"
              sx={{ width: '190px', marginY: '8px' }}
            >
              Support
            </Button>
            <Footnote />
          </footer>
        </div>
      )}
    </CategoryProvider>
  );
};
export default MainLayout;
